
import { Vue, Options, prop } from "vue-class-component";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import Checkbox from "primevue/checkbox";

export interface LastLocationOptionValue {
  cityCode: string;
  hubId: number;
}

export interface LastLocationOption {
  name: string;
  value: LastLocationOptionValue;
}

class Props {
  options = prop<LastLocationOption[]>({
    default: () => [],
  });

  modelValue = prop<LastLocationOptionValue[]>({
    default: () => [],
  });

  testIdPrefix = prop<string>({
    default: "urgent-pod",
  });

  placeholder = prop<string>({
    default: "Pilih lokasi terakhir",
  });

  title = prop<string>({
    default: "Lokasi terakhir",
  });
}

@Options({
  components: { CustomDropdown, Checkbox },
  emits: ["update:modelValue"],
  watch: {
    modelValue: {
      handler(newVal: LastLocationOptionValue[]) {
        this.selectedLastLocations = [...newVal];
      },
    },
  },
})
class LastLocationFilterSection extends Vue.with(Props) {
  selectedLastLocations: LastLocationOptionValue[] = [];
  lastLocationSelectedCount = "";

  mounted(): void {
    this.selectedLastLocations = [...this.modelValue];
  }

  get dropdownOptions() {
    return this.options.map((opt) => ({
      label: opt.name,
      value: { cityCode: opt.value.cityCode, hubId: opt.value.hubId },
    }));
  }

  get lastLocationModel(): string[] {
    return this.selectedLastLocations.map(
      (v) => `${v.cityCode}|${v.hubId}`,
    );
  }

  get selectedCount(): number {
    return this.selectedLastLocations.length;
  }

  get displayPlaceholder(): string {
    return this.selectedCount > 0
      ? this.$t("urgentDeliveryManagement.filter.selectedLastLocation", {num: this.selectedCount})
      : this.$t("urgentDeliveryManagement.filter.lastLocationPlaceholder");
  }

  onLastLocationChange() {
    this.$emit("update:modelValue", [...this.selectedLastLocations]);
  }

  reset(): void {
    this.selectedLastLocations = [];
    this.$emit("update:modelValue", []);
  }
}

export default LastLocationFilterSection;
